export default __webpack_public_path__ + "static/media/Frame-2.8a50352e.png";